module.exports = __webpack_public_path__ + "img/v-logo.b5eaf298.svg";